import OutsideClickHandler from "react-outside-click-handler";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";

const ConditionalOutsideClick = ({ children }) => {
  const navigate = useNavigate();

  const handleModalClose = () => {
    sessionStorage.removeItem("modalBackground");
    navigate(-1);
  };
  if (isMobile) return <>{children}</>;
  return (
    <OutsideClickHandler onOutsideClick={handleModalClose}>
      {children}
    </OutsideClickHandler>
  );
};

export default ConditionalOutsideClick;
